import UserLogo from './UserLogo';

export default UserLogo;
